import React from "react"
import {
  HiCheckCircle,
  HiShieldCheck,
  HiOutlineLightBulb,
  HiOutlineChartBar,
  HiOutlineCurrencyDollar,
  HiOutlineAcademicCap,
} from "react-icons/hi"
import "./AboutCordova.css"

const AboutCordova = () => {
  const scrollToBooking = () => {
    const element = document.getElementById("booking-form")
    const headerOffset = 80 // Account for sticky header height
    const elementPosition = element.offsetTop
    const offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  const whyChooseFeatures = [
    {
      category: "PROVEN BUSINESS MODEL",
      items: [
        {
          icon: HiOutlineCurrencyDollar,
          title: "Fast Track to $13.7M Revenue",
          description:
            "Skip years of trial and error. Our flagship location generates $13.7M annually using our proven systems. Get the exact blueprint, processes, and strategies that built this 8-figure business.",
        },
        {
          icon: HiOutlineLightBulb,
          title: "Complete Business Infrastructure",
          description:
            "Get everything you need: proprietary CRM, proven sales playbooks, marketing materials, operational procedures, and ongoing support. No need to build from scratch - we've perfected the formula.",
        },
        {
          icon: HiShieldCheck,
          title: "Exclusive Territory Rights",
          description:
            "Own your market with 100% territory protection. No competition from other Cordova franchisees in your area, giving you complete control and unlimited growth potential in your region.",
        },
      ],
    },
    {
      category: "FRANCHISE ADVANTAGES",
      items: [
        {
          icon: HiOutlineChartBar,
          title: "Recession-Proof Industry",
          description:
            "IT staffing is essential regardless of economic conditions. Companies always need skilled tech talent, and during downturns, they prefer flexible staffing solutions over permanent hires.",
        },
        {
          icon: HiCheckCircle,
          title: "High-Margin Business Model",
          description:
            "IT staffing offers exceptional profit margins with minimal overhead. Once established, your business generates recurring revenue through ongoing placements and contract renewals.",
        },
        {
          icon: HiOutlineAcademicCap,
          title: "90-Day Launch System",
          description:
            "Receive comprehensive training in sales, operations, and business development. Our proven 90-day system gets you operational quickly with ongoing support from our experienced team.",
        },
      ],
    },
  ]

  const franchiseDesignedFor = [
    "Executives, managers, and business developers",
    "Investors seeking a semi-absentee franchise model",
    "Professionals in staffing / recruiting",
    "Tech or B2B professionals ready to leverage their network",
  ]

  const notFor = [
    "Those without professional experience or the working capital to invest.",
  ]

  return (
    <section className='about-cordova-section section section-light-gray'>
      <div className='container'>
        {/* Why Choose Cordova Section */}
        <div className='why-choose-section'>
          <h3 className='why-choose-title'>Why Cordova?</h3>
          <p className='why-choose-intro'>
            Cordova Inc. has ranked on the Inc 5000 list 3 years running, driven
            by consistent national growth.
          </p>
          <div className='why-choose-grid'>
            {whyChooseFeatures.map((category, categoryIndex) => (
              <div key={categoryIndex} className='category-column'>
                <h4 className='category-title'>{category.category}:</h4>
                <div className='category-items'>
                  {category.items.map((item, itemIndex) => (
                    <div key={itemIndex} className='feature-item'>
                      <div className='feature-icon'>
                        <item.icon />
                      </div>
                      <div className='feature-content'>
                        <h5 className='feature-title'>{item.title}</h5>
                        <p className='feature-description'>
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className='btn-secondary learn-more-btn'
                  onClick={scrollToBooking}
                >
                  Learn More
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className='franchise-fit'>
          <div className='fit-highlight'>
            <div className='fit-highlight__header'>
              <span className='fit-badge'>Ideal owners</span>
              <h4>The Cordova Franchise is designed for:</h4>
              <p>
                Professionals who are ready to step into ownership with an
                established brand, proven systems, and protected territories.
              </p>
            </div>
            <div className='fit-pills'>
              {franchiseDesignedFor.map((item) => (
                <span key={item} className='fit-pill'>
                  {item}
                </span>
              ))}
            </div>
          </div>
          <div className='fit-callout'>
            <span className='fit-badge fit-badge--warning'>
              Press pause if…
            </span>
            <h4>It’s not for:</h4>
            <ul>
              {notFor.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p className='fit-callout__note'>
              Not sure if you align? Let&apos;s talk openly about your goals,
              capital, and timeline.
            </p>
            <button
              className='btn-secondary learn-more-btn'
              onClick={scrollToBooking}
            >
              Book a Call
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutCordova
